import { type ReactNode, useRef } from 'react';
import { LuX } from 'react-icons/lu';

import { EventView } from '@ndvr/customer-api';

import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import TaskOverlays from 'views/tasks/TaskOverlays';

import { getEventTitleMarkerClassName } from './event-details-shared';
import { EventDetailsContent } from './EventDetailsContent';

interface EventDetailsBubbleProps {
    event: EventView;
    onOpenChange: (open: boolean) => void;
    open: boolean;
    trigger: ReactNode;
}

export const EventDetailsBubble = ({ event, onOpenChange, open, trigger }: EventDetailsBubbleProps) => {
    const titleMarkerClassName = getEventTitleMarkerClassName(event);
    const contentRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <Popover modal open={open} onOpenChange={onOpenChange}>
                <PopoverTrigger asChild>{trigger}</PopoverTrigger>
                <PopoverContent
                    ref={contentRef}
                    side="left"
                    align="start"
                    sideOffset={18}
                    collisionPadding={24}
                    tabIndex={-1}
                    onOpenAutoFocus={(focusEvent) => {
                        focusEvent.preventDefault();
                        contentRef.current?.focus();
                    }}
                    className="z-[80] w-[min(34rem,calc(100vw-2rem))] rounded-[24px] border border-[#E7DED7] bg-white p-0 shadow-[0_28px_60px_rgba(67,57,56,0.2)]"
                >
                    <EventDetailsContent
                        event={event}
                        className="max-h-[min(78vh,720px)] overflow-y-auto px-5 py-5"
                        headerEndSlot={
                            <Button
                                type="button"
                                variant="ghost"
                                size="icon"
                                className="rounded-full"
                                onClick={() => onOpenChange(false)}
                                aria-label="Close event details"
                            >
                                <LuX className="h-4 w-4" />
                            </Button>
                        }
                        meetingBotEnabled={open}
                        onRequestClose={() => onOpenChange(false)}
                        titleMarkerClassName={titleMarkerClassName}
                    />
                </PopoverContent>
            </Popover>

            {open ? <TaskOverlays /> : null}
        </>
    );
};
